import { inject, observer, Provider } from "mobx-react";
import React, { Component } from "react";
import { Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { compose } from "recompose";

import { Auth0 } from "nvent-web/services/Auth0";
import { NotificationsStore } from "nvent-web/stores/Notifications";
import { UserStore } from "nvent-web/stores/User";

import { RegistrationFlow } from "../stores/RegistrationFlow";
import { CompanyStep } from "./components/CompanyStep";
import ConfirmationStep from "./components/ConfirmationStep";
import { CredentialsStep } from "./components/CredentialsStep";
import { PersonalStep } from "./components/PersonalStep";

interface RegisterInnerProps extends RouteComponentProps<{}> {
  user: UserStore;
  auth0: Auth0;
  notifications: NotificationsStore;
}

class RegisterInner extends Component<RegisterInnerProps> {
  private registration = new RegistrationFlow(
    this.props.user,
    this.props.auth0,
    this.props.history,
    this.props.notifications,
    this.props.match.url
  );

  render() {
    const basePath = this.props.match.path;

    return (
      <Provider registration={this.registration}>
        <Switch>
          <Route path={basePath} exact={true} component={CredentialsStep} />
          <Route path={`${basePath}/personal`} exact={true} component={PersonalStep} />
          <Route path={`${basePath}/company`} exact={true} component={CompanyStep} />
          <Route path={`${basePath}/confirmation`} exact={true} component={ConfirmationStep} />
        </Switch>
      </Provider>
    );
  }
}

const Register = compose<RegisterInnerProps, {}>(
  inject("user", "auth0", "notifications"),
  withRouter,
  observer
)(RegisterInner);

export default Register;
